import { Formik } from "formik";
import { FC, ReactNode, createContext } from "react";
import TableDSVatTu from "./component/TableDSVatTu";

export interface QuanLyKhoContextProps { };

interface QuanLyKhoProps {
    warehouseId?: number | undefined;
    customTitle?: ReactNode;
    className?: any;
    materialsGroup?: number;
}

const initialContext = {};

export const QuanLyKhoContext = createContext<QuanLyKhoContextProps>(initialContext)

export const QuanLyKho: FC<QuanLyKhoProps> = (props) => {
    const { warehouseId, className, customTitle, materialsGroup } = props;
    return (
        <Formik<any>
            initialValues={{}}
            onSubmit={() => { }}
        >
            <QuanLyKhoContext.Provider
                value={{}}
            >
                <div className="bg-white">

                    <div className="flex-1 flex flex-column">
                        <div className="py-1 ">
                            <TableDSVatTu
                                className={className}
                                warehouseId={warehouseId}
                                customTitle={customTitle ? customTitle : null}
                                materialsGroup={materialsGroup}
                            />
                        </div>
                    </div>


                </div>

            </QuanLyKhoContext.Provider>
        </Formik>
    )
}

export default QuanLyKho;
